module.exports = __webpack_public_path__ + "img/thumbnail-overlay.a2eb4849.png";